// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"wbac_innerWrapper__VgpIT","logoWrapper":"wbac_logoWrapper__xL_vn","logo":"wbac_logo__nqZWj","heading":"wbac_heading__qHZwT","cta":"wbac_cta__8Vq_T"};